// Utils
import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';

// Global Types
import { AppState } from 'services/types';

import { CropsurePasswordsState } from './types';

export const selectCropsurePasswords = (
    state: AppState
): CropsurePasswordsState => state.cropsurePasswords;

export const selectCropsurePasswordsArray = createDeepEqualSelector(
    selectCropsurePasswords,
    (cropsurePasswords) => Object.values(cropsurePasswords)
);

export const selectCropsurePasswordUuidsArray = createDeepEqualSelector(
    selectCropsurePasswordsArray,
    (cropsurePasswords) => cropsurePasswords.map(({ uuid }) => uuid)
);
